module.exports = __webpack_public_path__ + "media/images/icon__point--default@2x-de8e3273b81680bdc67fb09d156358c3.png";